import React, { useState } from "react";

const SidebarFilters = ({ vehicles, setDataVehicle }) => {
  const [filters, setFilters] = useState({
    make: "",
    model: "",
    year: "",
    state: "",
    vehicle_type: "",
    body_type: "",
    transmission: "",
    fuel: "",
    drive: "",
    odometer: "",
    title: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFilter = () => {
    const filtered = vehicles?.filter((vehicle) => {
      return (
        (filters?.make === "" ||
          vehicle.make?.toLowerCase().includes(filters?.make?.toLowerCase())) &&
        (filters?.model === "" ||
          vehicle.model
            ?.toLowerCase()
            .includes(filters?.model?.toLowerCase())) &&
        (filters?.year === "" || vehicle.year === Number(filters?.year)) &&
        (filters?.state === "" ||
          vehicle.state
            ?.toLowerCase()
            .includes(filters?.state?.toLowerCase())) &&
        (filters?.vehicle_type === "" ||
          vehicle.vehicle_type
            ?.toLowerCase()
            .includes(filters?.vehicle_type?.toLowerCase())) &&
        (filters?.body_type === "" ||
          vehicle.body_type
            ?.toLowerCase()
            .includes(filters?.body_type?.toLowerCase())) &&
        (filters?.transmission === "" ||
          vehicle.transmission
            ?.toLowerCase()
            .includes(filters?.transmission?.toLowerCase())) &&
        (filters?.fuel === "" ||
          vehicle.fuel?.toLowerCase().includes(filters?.fuel?.toLowerCase())) &&
        (filters?.drive === "" ||
          vehicle.drive
            ?.toLowerCase()
            .includes(filters?.drive?.toLowerCase())) &&
        (filters?.odometer === "" ||
          vehicle.odometer <= Number(filters?.odometer)) &&
        (filters?.title === "" ||
          vehicle.title?.toLowerCase().includes(filters?.title?.toLowerCase()))
      );
    });
    setDataVehicle(filtered);
  };

  const handleReset = () => {
    setFilters({
      make: "",
      model: "",
      year: "",
      state: "",
      vehicle_type: "",
      body_type: "",
      transmission: "",
      fuel: "",
      drive: "",
      odometer: "",
      title: "",
    });
    setDataVehicle(vehicles);
  };

  return (
    <div
      style={{ width: "300px", borderRight: "1px solid #ddd", padding: "15px" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 style={{ fontWeight: "bold", color: "#0A92E2" }}>Search Filters</h5>
        <button className="btn btn-link p-0" onClick={handleReset}>
          Reset All
        </button>
        <i className="fa-solid fa-filter"></i>
      </div>

      <div className="mb-3">
        <input
          type="text"
          name="title"
          value={filters?.title}
          onChange={handleChange}
          className="form-control mb-3"
          placeholder="Title"
        />
        <input
          type="text"
          name="make"
          value={filters?.make}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Make"
        />
        <input
          type="text"
          name="model"
          value={filters?.model}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Model"
        />
        <input
          type="number"
          name="year"
          value={filters?.year}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Year"
        />
        <input
          type="text"
          name="state"
          value={filters?.state}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="State"
        />
        <input
          type="text"
          name="vehicle_type"
          value={filters?.vehicle_type}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Vehicle Type"
        />
        <input
          type="text"
          name="body_type"
          value={filters?.body_type}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Body Type"
        />
        <input
          type="text"
          name="transmission"
          value={filters?.transmission}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Transmission"
        />
        <input
          type="text"
          name="fuel"
          value={filters?.fuel}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Fuel Type"
        />
        <input
          type="text"
          name="drive"
          value={filters?.drive}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Drivetrain"
        />
        <input
          type="number"
          name="odometer"
          value={filters?.odometer}
          onChange={handleChange}
          className="form-control mb-2"
          placeholder="Max Odometer"
        />
        <button className="theme-btn w-100 mt-0" onClick={handleFilter}>
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default SidebarFilters;
